module.exports = __webpack_public_path__ + "img/clip.1e0ef1dc.svg";